import TimeSeriesChartConfiguration
  from "./dashboard/widgets/timeseries-chart/time-tick-formatter/timeSeriesChartCongiguration.jsx";
import LegendEdit from "./dashboard/widgets/timeseries-chart/legend/legendEdit.jsx";
import TimeLineControl from "./dashboard/widgets/timeseries-chart/time-line-control/timeLineControl.jsx";

const MobileDetect = require('mobile-detect');

import Header from "./header/header.jsx";
import PreLoader from "./common/preloader.jsx";
import BaseComponent from "./baseComponent.js";
import InternalEvent from "../core/constants/internalEvent.js";
import AppModal from "./common/app-modal/appModal.jsx";
import VersionCheckModal from './common/versionCheckModal.jsx';
import DisconnectionModal from './common/disconnectionModal.jsx';
import AppService from '../core/services/app-service';

import {fromEvent} from 'rxjs/observable/fromEvent';
import {throttleTime, map} from 'rxjs/operators';

import styles from './app.scss';
import React from "react";


window.isMobile = function () {
  // return true;
  const md = new MobileDetect(window.navigator.userAgent);
  return window.forceDesktopMode ? false : md.phone();
};

window.validateEmail = function (email) {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export default class App extends BaseComponent {
  constructor(props) {
    super(props);
    this.loadEpoch();
    this.currentVersion = undefined;
    this.newVersionNotified = false;
    this.state = {
      timeSeriesWidget: null,
      legendConfig: null,
      timeControl: null
    };
    fromEvent(window, 'resize')
      .pipe(
        throttleTime(300),
        map(_ => AppService.setDisplaySize(window.innerWidth))
      ).subscribe();
  }

  componentDidMount() {
    this.publish(InternalEvent.App.INITIALIZED);
    if ($(this.refs.navbarToggle).is(":visible")) {
      $(".navbar").css("transform", "translate(0, -45px)");
    }
    this.subscribeEvents();
    this.showPreloader();
    this.checkVersion();
    setInterval(() => {
      this.checkVersion();
    }, 60000);
    $("#loading").hide();

    this.subscribe('openTimeSeriesWidgetConfig', widget => {
      this.setState({timeSeriesWidget: widget}, () => {
        this.refs.timeTickFormatter.show();
      });
    });

    this.subscribe('openTimeControl', widget => {
      this.setState({timeControl: widget}, () => {
        this.refs.timeControl.show();
      });
    });

    this.subscribe('openLegendConfig', payload => {
      this.setState({
        legendConfig: {
          legends: payload.legends,
          widgetId: payload.widgetId
        }
      }, () => {
        this.refs.legendEdit.show();
      });
    });
  }

  checkVersion() {
    $.get('version', (data) => {
      const version = data.split('\n')[0].split('@')[1];
      if (/^\d{1,2}\.\d{1,2}\.\d{1,2}$/.test(version)) {
        console.log(`version: ${version}`);
        if (this.currentVersion === undefined) {
          this.currentVersion = version;
        } else {
          if (this.currentVersion !== version) {
            console.log('new version:' + version);
            this.notifyNewVersion();
            this.currentVersion = version;
          }
        }
      }
    });
  }

  notifyNewVersion() {
    if (!this.newVersionNotified) {
      this.refs.versionCheckModal.show();
      this.newVersionNotified = true;
    }
  }

  loadEpoch() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../src-epoch/epoch-0.6.0.js');
          resolve();
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }

  subscribeEvents() {
    this.subscribe(InternalEvent.App.SHOW_PRELOADER, this.showPreloader);
    this.subscribe(InternalEvent.App.HIDE_PRELOADER, this.hidePreloader);
    this.subscribe('solaceException', () => {
      this.refs.disconnectionModal.show();
    });
    this.subscribe('reconnected', () => {
      this.refs.disconnectionModal.reconnected();
      setTimeout(() => {
        this.refs.disconnectionModal.hide();
      }, 1000);
    })
  }

  onBodyClick(event) {
    // Global click event for closing popup etc...
    let target = event.target;
    this.publish(InternalEvent.App.DOCUMENT_CLICKED, target);

    if (window.isMobile()) {
      if (event.target.classList.value.indexOf('navbar-toggle') === -1) {
        this.publish(InternalEvent.App.HIDE_NAVBAR);
      }
    }
  }

  showPreloader() {
    this.refs.preloader.show();
  }

  hidePreloader() {
    this.refs.preloader.hide();
  }

  handleNavbarToggleBtnClick() {
    this.publish(InternalEvent.App.SHOW_NAVBAR);
  }

  render() {
    return (
      <div className={styles.container} onClick={(e) => this.onBodyClick(e)}>
        <div className={styles.logoMobile}></div>
        {
          isMobile() ? <div className={styles.navbarToggle}>
            <i className="material-icons navbar-toggle" ref="navbarToggle"
               onClick={this.handleNavbarToggleBtnClick}>menu</i>
          </div> : null
        }
        <Header/>
        {this.props.children}
        <div className={styles.preloader}>
          <PreLoader ref="preloader"/>
        </div>
        <AppModal/>
        <VersionCheckModal ref="versionCheckModal"/>
        <DisconnectionModal ref="disconnectionModal"/>
        {this.state.timeSeriesWidget ?
          <TimeSeriesChartConfiguration widget={this.state.timeSeriesWidget} widgetId={this.state.timeSeriesWidget.id}
                                        ref="timeTickFormatter"/> : null}
        {this.state.legendConfig ?
          <LegendEdit widgetId={this.state.legendConfig.widgetId}
                      legends={this.state.legendConfig.legends}
                      ref="legendEdit"/> : null}
        {this.state.timeControl ? <TimeLineControl widget={this.state.timeControl} ref="timeControl"/> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app.jsx